import { render, staticRenderFns } from "./x-filters-list.component.vue?vue&type=template&id=5cd00d02&scoped=true"
import script from "./x-filters-list.component.vue?vue&type=script&lang=ts"
export * from "./x-filters-list.component.vue?vue&type=script&lang=ts"
import style0 from "./x-filters-list.component.vue?vue&type=style&index=0&id=5cd00d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd00d02",
  null
  
)

export default component.exports